import React, {useEffect, useState} from "react";
import {mediumTextStyles} from "../Style";
import {Row, Spinner} from "react-bootstrap";
import NavigateCarInsurance from "./NavigateCarInsurance";
import EverydayPlusDetails from "./EverydayPlusDetails";
import Cookies from "js-cookie";
import ThirdPartyFireTheft from "./ThirdPartyFireTheft";
import ThirdParty from "./ThirdParty";
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";
import DeclarationPopup from "./DeclarationPopup";

const PolicyDetails = (props) => {
  let url = process.env.REACT_APP_MODE !== null && process.env.REACT_APP_MODE !== undefined && process.env.REACT_APP_MODE.includes('dev') ? 'http://localhost:8080/edge' : '/edge';
  const [loading, setLoading] = useState(true); // Loading state
  const [showDeclStatement, setShowDeclStatement] = useState(false);
  const [isNextButtonDisabled, setIsNextButtonDisabled] = useState(false); // Track Next button state
  const {executeRecaptcha} = useGoogleReCaptcha();
  const [verificationFailedStep, setVerificationFailedStep] = useState('');

  useEffect(() => {
    if (verificationFailedStep === 'amendQuote') {
      amendQuote();
    }
  }, [props.inputValues.isRecaptchaV2Verified]);

  const InsuranceDetails = ({type}) => {
    let details = '';

    const containerStyle = {
      border: "2px solid #1851A3",
      padding: "20px",
      width: "100%",
      maxWidth: "1000px"
      //borderRadius: "0 5px 5px 5px",
    };

    if (type === 'COMPREHENSIVE') {

      return (<>
          <EverydayPlusDetails
            handleChangeValue={props.handleChangeValue}
            amendQuote={amendQuote}
            responseJson={JSON.parse(props.inputValues.responseJson)}
            inputValues={props.inputValues}
            nextStep={props.nextStep}
            prevStep={props.prevStep}
          /></>
      );
    } else if (type === 'THIRD_PARTY_FIRE_THEFT') {
      return (<>
          <ThirdPartyFireTheft
            handleChangeValue={props.handleChangeValue}
            amendQuote={amendQuote}
            responseJson={JSON.parse(props.inputValues.responseJson)}
            inputValues={props.inputValues}
            nextStep={props.nextStep}
            prevStep={props.prevStep}
          /></>
      );
    } else if (type === 'THIRD_PARTY') {
      return (<>
          <ThirdParty
            handleChangeValue={props.handleChangeValue}
            amendQuote={amendQuote}
            responseJson={JSON.parse(props.inputValues.responseJson)}
            inputValues={props.inputValues}
            nextStep={props.nextStep}
            prevStep={props.prevStep}
          /></>
      );
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    amendQuote();

  }, [props.inputValues.excessFreeWindow, props.inputValues.hireCar, props.inputValues.roadSideAssistance, props.inputValues.excess, props.inputValues.paymentFrequency, props.inputValues.vehicleValue, props.inputValues.insuranceCover, props.inputValues.policyStartDate, props.inputValues.declarationPopupShow]);

  const amendQuote = async () => {
    props.handleChangeValue("quoteNumber", JSON.parse(props.inputValues.responseJson).data.attributes.policyDetails.quoteNum);
    setLoading(true);
    let jwt = Cookies.get('jwt-token');

    let date = props.inputValues.policyStartDate && props.inputValues.policyStartDate !== ""
      ? new Date(props.inputValues.policyStartDate)  // Use the provided date
      : new Date();  // Use the current date if not valid
    let isoDateTime = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString();
    let startDate = isoDateTime.slice(0, 10);
    date.setFullYear(date.getFullYear() + 1);
    isoDateTime = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString();
    let expiryDate = isoDateTime.slice(0, 10);
    let mainDriverIncidents = [];
    let driver1 = props.inputValues.driverList.driver1;
    for (let i = 1; i < 5; i++) {

      if (driver1.incidentList["incidents" + i].claimCode !== '') {
        mainDriverIncidents.push(driver1.incidentList["incidents" + i]);
      }
    }
    const driverArray = Object.keys(props.inputValues.driverList).map(key => props.inputValues.driverList[key]);

    const additionalDriverArray = [];

    driverArray.map((driver, idx) => {
      if (idx !== 0 && driver.firstName !== '') {
        let incidentList = [];
        for (let i = 1; i < 5; i++) {
          if (driver.incidentList["incidents" + i].claimCode !== '') {
            incidentList.push(driver.incidentList["incidents" + i]);
          }
        }
        let additionalDriver = {
          "dateOfBirth": driver.dateOfBirth.split("/").reverse().join("-"),
          "claimHistory": incidentList
        };
        additionalDriverArray.push(additionalDriver);
      }
    })
    if (!executeRecaptcha) {
      console.log('reCAPTCHA is not ready');
      return;
    }
    let token = await executeRecaptcha('submit');
    if (props.inputValues.isRecaptchaV2Verified) {
      token = "AUTHENTICATED_V2"
    }
    if (!jwt) {
      window.location.href = `/error-occurred`;
    }
    fetch(url + '/vero/quote/amend', {

      method: "POST",
      mode: "cors",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${jwt}`
      }),
      body: JSON.stringify(
        {
          "attributes": {
            "coverages": [
              {
                "compensations": [
                  {
                    "appliedIndicator": true,
                    "compensationSubType": "AgreedValue",
                    "compensationType": "SumInsured",
                    "value": props.inputValues.insuranceCover === 'THIRD_PARTY' ? 0 : props.inputValues.vehicleValue
                  },
                  {
                    "appliedIndicator": true,
                    "compensationSubType": "MarketValue",
                    "compensationType": "SumInsured",
                    "value": props.inputValues.insuranceCover === 'THIRD_PARTY' ? 0 : props.inputValues.vehicleValue
                  },
                  {
                    "appliedIndicator": props.inputValues.excessFreeWindow,
                    "compensationSubType": "WindscreenExcessWaiver",
                    "compensationType": "CoverType"
                  },
                  {
                    "appliedIndicator": true,
                    "code": props.inputValues.insuranceCover === 'COMPREHENSIVE' && props.inputValues.hireCar ? "LIMITED_HIRE_CAR" : "HIRE_CAR_NOT_TAKEN",
                    "compensationSubType": "HireCar",
                    "compensationType": "CoverType"
                  },
                  {
                    "appliedIndicator": true,
                    "code": "NOT_ELIGIBLE",
                    "compensationSubType": "LifetimeNewForOld",
                    "compensationType": "CoverType"
                  },
                  {
                    "appliedIndicator": props.inputValues.insuranceCover === 'COMPREHENSIVE' ? props.inputValues.roadSideAssistance : false,
                    "compensationSubType": "RoadsideAssist",
                    "compensationType": "CoverType"
                  }
                ],
                "policyCoverType": props.inputValues.insuranceCover,
                "risk": {
                  "addressDetails": {
                    "addressId": props.inputValues.riskAddressId,
                    "addressInBrokenDownForm": {
                      "streetName": props.inputValues.riskStreetName,
                      "streetNumber": props.inputValues.riskStreetNumber,
                      "streetType": props.inputValues.riskStreetType,
                      "buildingName": props.inputValues.riskBuildingName,
                      "levelNumber": props.inputValues.riskLevelNumber,
                      "levelType": props.inputValues.riskLevelType,
                      "streetSuffixCode": props.inputValues.riskStreetSuffixCode,
                      "unitNumber": props.inputValues.riskUnitNumber,
                      "unitType": props.inputValues.riskUnitType,
                    },
                    "addressInFreeForm": {
                      "addressLine1": props.inputValues.riskAddressLine1,
                      "addressLine2": props.inputValues.riskAddressLine2,
                    },
                    "postcode": props.inputValues.riskPostcode,
                    "signature": props.inputValues.riskSignature,
                    "suburb": props.inputValues.riskSuburb
                  },
                  "vehicleRisk": {
                    "accessoriesIndicator": false,
                    "damagedIndicator": false,
                    "financeIndicator": props.inputValues.isFinanced === "YES",
                    "additionalDrivers": additionalDriverArray,
                    "mainDriver": {
                      "claimHistory": mainDriverIncidents,
                      "dateOfBirth": props.inputValues.driverList.driver1.dateOfBirth.split("/").reverse().join("-")
                    },
                    "modificationIndicator": false,
                    "vehicleKey": props.inputValues.vehicleKey,
                    "vehicleUsageType": "PRIVATE"
                  }
                },
                "voluntaryExcess": props.inputValues.insuranceCover === 'COMPREHENSIVE' ? props.inputValues.excess : 0
              }
            ],
            "policyHistory": {
              "lastModifiedDatetime": JSON.parse(props.inputValues.responseJson).data.attributes.policyDetails.policyHistory.lastModifiedDatetime,
              "lastModifiedUserId": JSON.parse(props.inputValues.responseJson).data.attributes.policyDetails.policyHistory.lastModifiedUserId
            },
            "quoteNumber": JSON.parse(props.inputValues.responseJson).data.attributes.policyDetails.quoteNum,
            "quoteRequestDetails": {
              "frequency": props.inputValues.paymentFrequency,
              "policyExpiryDate": expiryDate,
              "policyInceptionDate": startDate,
              "previousInsurer": "NONE"
            }
          },
          "type": "string",
          "recaptchaResponse": token
        }
        // {"attributes":{"coverages":[{"compensations":[{"appliedIndicator":true,"compensationSubType":"AgreedValue","compensationType":"SumInsured","value":15000},{"appliedIndicator":true,"compensationSubType":"MarketValue","compensationType":"SumInsured","value":15000},{"appliedIndicator":false,"compensationSubType":"WindscreenExcessWaiver","compensationType":"CoverType"},{"appliedIndicator":true,"code":"HIRE_CAR_NOT_TAKEN","compensationSubType":"HireCar","compensationType":"CoverType"},{"appliedIndicator":true,"code":"NOT_ELIGIBLE","compensationSubType":"LifetimeNewForOld","compensationType":"CoverType"},{"appliedIndicator":false,"compensationSubType":"RoadsideAssist","compensationType":"CoverType"}],"policyCoverType":"COMPREHENSIVE","risk":{"addressDetails":{"addressId":"lUehd0gPgdL7FOGHQupuXBROntGLNm6wj66a0SsavQaXsKAYqpnZV9askzSBR8TE","addressInBrokenDownForm":{"streetName":"MANUKAU","streetNumber":"100","streetType":"RD"},"addressInFreeForm":{"addressLine1":"100 Manukau Rd"},"postcode":"1023","signature":"4TTiwKhzTf8t/twBDXACcZ/MnbZ3SszWCAQgu27b6xg=","suburb":"EPSOM"},"vehicleRisk":{"accessoriesIndicator":false,"additionalDrivers":[],"damagedIndicator":false,"financeIndicator":false,"mainDriver":{"claimHistory":[],"dateOfBirth":"1990-11-11"},"modificationIndicator":false,"vehicleKey":"0ATnSOMvvQ/q8WHUdGGSmQ==","vehicleUsageType":"PRIVATE"}},"voluntaryExcess":300}],"quoteRequestDetails":{"frequency":"FORTNIGHTLY","policyExpiryDate":"2025-03-27","policyInceptionDate":"2024-03-27","previousInsurer":"NONE"}},"type":"string"}

      )
    })
      .then(response => {
        if (response.status === 428) {
          // Show fallback captcha for 428 status
          console.log('Primary reCAPTCHA failed for vehicle lookup, showing fallback captcha');
          //setIsSubmitting(false);
          props.handleChangeValue("showRecaptchaPopup", true);
          setVerificationFailedStep("amendQuote");
          return null;
        }
        return response.json();
      })
      .then(data => {
        if (!data) return;
        props.handleChangeValue('responseJson', JSON.stringify(data));
        // Extracting policyComponent from data
        const policyComponent = data.data.attributes.policyComponent;
        const premium = props.inputValues.paymentFrequency === "ANNUAL" ?
          policyComponent.premium.grossPremium :
          policyComponent.premium.installmentAmount;
        props.handleChangeValue('premium', premium);
        setLoading(false);
      })
      .catch(error => {
        console.log('Error:', error);
        window.location.href = `/error-occurred`;
      });
  }
  if (loading) {
    return <>
      <div className="text-center mt-4" style={{height: "100%", minHeight: "100vh"}}>
        {" "}
        <Spinner animation="border" role="status">
          {" "}
          <span className="visually-hidden">Loading...</span>
          {" "}
        </Spinner>
        {" "}
      </div>
    </>
      ;
  }
  const steps = [// {name: 'Step 1', status: 'complete'},
    {name: 'Step 1', status: 'complete', desc: 'Car'}, {
      name: 'Step 2',
      status: 'complete',
      desc: 'Driver'
    }, {name: 'Step 3', status: 'current', desc: 'Quote'}, {
      name: 'Step 4',
      status: 'upcoming',
      desc: 'Policyholder'
    }, {name: 'Step 5', status: 'upcoming', desc: 'Payment'},];

  return (<>
    <br/><br/>
    <Row className="justify-content-center">
      <NavigateCarInsurance steps={steps}/>
    </Row>
    <div className="lg-car-padding sm-car-padding">
      <div>
        <div className="sm-display-center" style={{paddingBottom: "30px", paddingTop: "20px"}}>
                <span style={mediumTextStyles}>
                   Select your cover type
                </span>
        </div>
      </div>

      <div>
        <div style={{display: "flex", gap: "5px"}}>

          <button
            style={{
              color: props.inputValues.insuranceCover === 'COMPREHENSIVE' ? '#1851A3' : '#6B7280',
              lineHeight: "16px",
              wordWrap: 'break-word',
              borderBottomColor: props.inputValues.insuranceCover === 'COMPREHENSIVE' ? 'transparent !important' : '2px solid #808080',
              border: props.inputValues.insuranceCover === 'COMPREHENSIVE' ? '2px solid #1851A3' : '#F2F2F2',
              borderBottom: props.inputValues.insuranceCover === 'COMPREHENSIVE' ? 'none' : '2px solid #1851A3',
              backgroundColor: props.inputValues.insuranceCover === 'COMPREHENSIVE' ? '#ffffff' : '#f2f2f2',
              paddingLeft: 25,
              paddingRight: 25,
              paddingTop: 13,
              paddingBottom: 13,
              width: "100%",
              maxWidth: "200px",
              boxShadow: props.inputValues.insuranceCover === 'COMPREHENSIVE' ? "none" : '0px 1px 2px rgba(0, 0, 0, 0.05)',
              borderRadius: "6px 6px 0 0",
              top: "2px",
              position: "relative",
              overflow: 'hidden',
              justifyContent: 'center',
              alignItems: 'center',
              display: 'inline-flex',
              cursor: 'pointer',
              opacity: 1,

            }}
            onClick={() => {
              props.handleChangeValue('insuranceCover', 'COMPREHENSIVE');
              setIsNextButtonDisabled(false);  // Update isNextButtonDisabled
            }}>
            <span style={{ hyphens: 'auto', WebkitHyphens: 'auto' }}> Everyday Plus<br/>(Compre&shy;hensive)</span>
          </button>
          <button
            onClick={() => props.handleChangeValue('insuranceCover', 'THIRD_PARTY_FIRE_THEFT')}
            style={{
              color: props.inputValues.insuranceCover === 'THIRD_PARTY_FIRE_THEFT' ? '#1851A3' : '#6B7280',
              lineHeight: "16px",
              wordWrap: 'break-word',
              borderBottomColor: props.inputValues.insuranceCover === 'THIRD_PARTY_FIRE_THEFT' ? 'transparent !important' : '2px solid #808080',
              border: props.inputValues.insuranceCover === 'THIRD_PARTY_FIRE_THEFT' ? '2px solid #1851A3' : '#F2F2F2',
              borderBottom: props.inputValues.insuranceCover === 'THIRD_PARTY_FIRE_THEFT' ? 'none' : '2px solid #1851A3',
              backgroundColor: props.inputValues.insuranceCover === 'THIRD_PARTY_FIRE_THEFT' ? '#ffffff' : '#f2f2f2',
              paddingLeft: 25,
              paddingRight: 25,
              paddingTop: 13,
              paddingBottom: 13,
              width: "100%",
              maxWidth: "200px",
              boxShadow: props.inputValues.insuranceCover === 'THIRD_PARTY_FIRE_THEFT' ? "none" : '0px 1px 2px rgba(0, 0, 0, 0.05)',
              borderRadius: "6px 6px 0 0",
              top: "2px",
              position: "relative",
              overflow: 'hidden',
              justifyContent: 'center',
              alignItems: 'center',
              display: 'inline-flex',
              cursor: 'pointer',
              opacity: 1
            }}
          >Third Party, Fire & Theft
          </button>
          <button
            onClick={() => {
              props.handleChangeValue('insuranceCover', 'THIRD_PARTY');
              setIsNextButtonDisabled(false);
            }}
            style={{
              color: props.inputValues.insuranceCover === 'THIRD_PARTY' ? '#1851A3' : '#6B7280',
              lineHeight: "16px",
              wordWrap: 'break-word',
              borderBottomColor: props.inputValues.insuranceCover === 'THIRD_PARTY' ? 'transparent !important' : '#F2F2F2',
              border: props.inputValues.insuranceCover === 'THIRD_PARTY' ? '2px solid #1851A3' : '#F2F2F2',
              borderBottom: props.inputValues.insuranceCover === 'THIRD_PARTY' ? 'none' : '2px solid #1851A3',
              backgroundColor: props.inputValues.insuranceCover === 'THIRD_PARTY' ? '#ffffff' : '#f2f2f2',
              paddingLeft: 25,
              paddingRight: 25,
              paddingTop: 13,
              paddingBottom: 13,
              width: "100%",
              maxWidth: "200px",
              boxShadow: props.inputValues.insuranceCover === 'THIRD_PARTY' ? "none" : '0px 1px 2px rgba(0, 0, 0, 0.05)',
              borderRadius: "6px 6px 0 0",
              top: "2px",
              position: "relative",
              overflow: 'hidden',
              justifyContent: 'center',
              alignItems: 'center',
              display: 'inline-flex',
              cursor: 'pointer',
              opacity: 1
            }}
          >Third Party Property Damage
          </button>
        </div>
        <InsuranceDetails type={props.inputValues.insuranceCover}/>
      </div>
    </div>
    <DeclarationPopup
      parentDeclarationPopupShow={props.inputValues.declarationPopupShow}
      setParentShowDeclStatement={setShowDeclStatement}
      parentNextStep={props.nextStep}
      handleChangeValue={props.handleChangeValue}
    />
  </>);
}
export default PolicyDetails;
